function ShopMap(){
    this.build();
    resizeCallbacks.push(this);
}

ShopMap.prototype.build = function(){

    if( $("#map").length > 0 ){

        let that = this;
        this.polygons = [];

        this.mapView = $('#map');

        this.bounds = new google.maps.LatLngBounds();
        let shops = $('.map-marker');
        this.markers = [];

        var icon = {
            url: $('#map').data('marker'),
            scaledSize: new google.maps.Size(25, 37),
            // origin: new google.maps.Point(0,0),
            // anchor: new google.maps.Point(0, 0)
        };

        this.map = new google.maps.Map(document.getElementById('map'), {
            center: {
                lat: 45.619722,
                lng: 4.6730292
            },
            zoom: 15,
            streetViewControl: false,
            mapTypeControl: false,
            fullscreenControl: false,
            zoomControlOptions: {
                position: google.maps.ControlPosition.LEFT_CENTER
            },
            styles: [
                {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#e9e9e9"
                        },
                        {
                            "lightness": 17
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#f5f5f5"
                        },
                        {
                            "lightness": 20
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        },
                        {
                            "lightness": 17
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        },
                        {
                            "lightness": 29
                        },
                        {
                            "weight": 0.2
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        },
                        {
                            "lightness": 18
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        },
                        {
                            "lightness": 16
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#f5f5f5"
                        },
                        {
                            "lightness": 21
                        }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#dedede"
                        },
                        {
                            "lightness": 21
                        }
                    ]
                },
                {
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "visibility": "on"
                        },
                        {
                            "color": "#ffffff"
                        },
                        {
                            "lightness": 16
                        }
                    ]
                },
                {
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "saturation": 36
                        },
                        {
                            "color": "#333333"
                        },
                        {
                            "lightness": 40
                        }
                    ]
                },
                {
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#f2f2f2"
                        },
                        {
                            "lightness": 19
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#fefefe"
                        },
                        {
                            "lightness": 20
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#fefefe"
                        },
                        {
                            "lightness": 17
                        },
                        {
                            "weight": 1.2
                        }
                    ]
                }
            ]
        });

        let infoWindow = new google.maps.InfoWindow();
        let activeInfoWindow;

        shops.each(function(){

            let address = $(this).data('address');
            let url = $(this).data('url');
            let contentString = $(this).html();

            marker = new google.maps.Marker({
                address: address,
                position: {
                    lat: $(this).data('lat'),
                    lng: $(this).data('lng')
                },
                map: that.map,
                icon : icon
            });
            if( url ){
                marker.addListener('click', function(){
                    window.location = url;
                });
            }

            (function (marker, data) {
                google.maps.event.addListener(marker, "mouseover", function (e) {
                    infoWindow.setContent(contentString);
                    infoWindow.open(map, marker);
                    activeInfoWindow = infoWindow;
                });
                google.maps.event.addListener(marker, "mouseout", function (e) {
                    if (activeInfoWindow) { activeInfoWindow.close(); }
                });
            })(marker,that.markers);

            that.markers.push(marker);
            that.bounds.extend(marker.getPosition());

        });

        if( this.markers.length > 1 ) {
            this.map.fitBounds(this.bounds);
        }else{
            this.map.setCenter(that.markers[0].getPosition());
        }

    }
};

ShopMap.prototype.resize = function(){
    if( this.markers.length > 1 ) {
        this.map.fitBounds(this.bounds);
    }
};